module.exports = __webpack_public_path__ + "static/fonts/DINPro-Black.2b3807ed.ttf";